import AuthLayout from '../Layouts/AuthLayout';

import FormLogin from '../Components/FormLogin';

function App() {
    return (
        <AuthLayout>
            <div className="mx-auto w-full max-w-[480px]">
                <div className="text-center">
                    <div className="mx-auto mb-8 2xl:mb-12 flex flex-col">
                        <img src={`/assets/img/rometal-logo.png`} alt="logo" className="block w-1/2 max-w-[300px] mx-auto" />
                    </div>

                    <FormLogin />
                </div>
            </div>
        </AuthLayout>
    );
}

export default App;
